<template>
    <div>
        <facebook></facebook>
        <vk></vk>
        <google></google>
        <metrika></metrika>
        <amplitude></amplitude>
    </div>
</template>

<script>
    import Vk from './vk.vue'
    import Facebook from './facebook.vue'
    import Google from './google.vue'
    import Metrika from './metrika.vue'
    import Amplitude from './amplitude.vue';

    export default {
        name: 'Analytics',
        data() {
            return {}
        },
        methods: {},
        components: {
            Amplitude,
            Vk,
            Facebook,
            Google,
            Metrika
        },
    }
</script>
